import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '@wix/da-ds/pkg/Icons/24x24/Close';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
var UnsubscribeVariant = function (_a) {
    var tier = _a.tier, className = _a.className, _b = _a.size, size = _b === void 0 ? 'medium' : _b, href = _a.href, onUnsubscribe = _a.onUnsubscribe;
    var _c = useState(false), isHovered = _c[0], setIsHovered = _c[1];
    var t = useTranslation().t;
    return (React.createElement(SolidButton, { className: className, size: size, variant: isHovered ? 'destructive-red' : 'approval-green', priority: "secondary", href: href, icon: isHovered ? Close : undefined, onClick: function (e) {
            onUnsubscribe(tier);
            e.stopPropagation();
        }, onMouseEnter: function (e) {
            setIsHovered(true);
        }, onMouseLeave: function (e) {
            setIsHovered(false);
        } }, t(isHovered ? 'deviation.tier.unsubscribe' : 'deviation.tier.subscribed')));
};
UnsubscribeVariant.displayName = 'UnsubscribeVariant';
export default UnsubscribeVariant;
//# sourceMappingURL=Unsubscribe.js.map